import type { CustomEventsContext } from '../types'

export default function (this: CustomEventsContext, status: string) {
  this.sendEvent('subscription.transaction.done.ios', { status })
}
